(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.disciplinequickentry = skyward.disciplinequickentry || {};

        skyward.disciplinequickentry.addNewChildRecordRow = function (input)
        {
            var jqInput = $(input);
            if (jqInput.hasClass('InvolvementQuickEntryAddButton')) {
                var involvementTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                involvementTableRow.css("display", "");
                var involvementRow = involvementTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (involvementRow.length)
                {
                    skyward.window.notifyDOMLoad(involvementRow.attr("id"));
                }
            }
            if (jqInput.hasClass('WeaponQuickEntryAddButton'))
            {
                var weaponTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                weaponTableRow.css("display", "");
                var weaponRow = weaponTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (weaponRow.length)
                {
                    skyward.window.notifyDOMLoad(weaponRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('DrugQuickEntryAddButton'))
            {
                var drugTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                drugTableRow.css("display", "");
                var drugRow = drugTableRow.find(".childrecordquickentry").find(".childrecordquickentryrow:visible").last();
                if (drugRow.length)
                {
                    skyward.window.notifyDOMLoad(drugRow.attr("id"));
                }
            }
            else if (jqInput.hasClass('ActionQuickEntryAddButton'))
            {
                var table = jqInput.closest("tr.childrecordquickentryrow");
                var actionTableRow = jqInput.siblings('.CollapsibleChildRecordQuickEntry');
                actionTableRow.css("display", "");
                table.find('.actioncount').val('1');

                setActionCodeEELDependency(actionTableRow);
                setFollowUpDistintMultiSelectDependency(actionTableRow);

                var actionIDForAjax = actionTableRow.find("[name*='ActionID']").attr('name');
                var actionValueForAjax = actionTableRow.find("[name*='ActionID']").attr('value');

                var ajaxData = {
                    _controlAjaxFiredFrom: actionIDForAjax
                }
                ajaxData[actionIDForAjax] = actionValueForAjax;

                var actionRow = table.find(".actionQuickEntry").find(".childrecordquickentryrow:visible").last();
                if (actionRow.length)
                {
                    $.when(skyward.window.notifyDOMLoad(actionRow.attr("id"))).then(
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Discipline/Incident/QuickEntryAjaxAdministrative",
                                type: "POST",
                                dataType: "JSON",
                                data: ajaxData,
                                success: function (data)
                                {
                                    skyward.ajax.handleResponse(data, "", false, $(actionRow.attr("id")).closest('.skywardContentPanel'));
                                }
                            }));
                }
            }
            skyward.window.notifyResize();
            jqInput.css("display", "none");
        };

        var init = function (selector)
        {
            // Discipline list dynamic Discipline Officer filtering
            if ($(selector + ' #DisciplineListIncidentBrowse').length > 0)
            {
                var browseName = skyward.browse.getCurrentBrowseName();
                var browse = skyward.browse.browseList[browseName];
                if (!browse)
                {
                    return;
                }
                const browseInitialFilter = browse.data.filter;
                const browseInitialRequestDataHash = browse.requestDataHash;

                var disciplineOfficerEEL = $('#DisciplineListStaffIDDisciplineOfficer_value');
                disciplineOfficerEEL.parent().on("eelComplete", function ()
                {
                    var tileViewEEL = $(this).parent().find('.tileViewEEL');
                    generateIncidentFilter(tileViewEEL);

                    updateIncidentListSelectedDisciplineOfficerUserSetting(skyward.controls.getValue(tileViewEEL));
                });

                disciplineOfficerEEL.on('change', function ()
                {
                    var tileViewEEL = $(this);
                    var value = skyward.controls.getValue(tileViewEEL);
                    if (value === '')
                    {
                        generateIncidentFilter(tileViewEEL.parent('.tileViewEEL'));
                        updateIncidentListSelectedDisciplineOfficerUserSetting(value);
                    }
                });

                var generateIncidentFilter = function (tileViewEEL)
                {
                    if (!tileViewEEL || !tileViewEEL.hasClass('tileViewEEL'))
                    {
                        return;
                    }

                    const browseRequiredData = skyward.browse.getRequiredBrowseData(browse);
                    const postData = browseRequiredData.postData;

                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/GenerateIncidentFilter",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineListStaffIDDisciplineOfficer: skyward.controls.getValue(tileViewEEL),
                            postData,
                        },
                        success: function (data)
                        {
                            browse.dynamicFilterValues.filter = data.SearchCondition;
                            browse.dynamicFilterValues.filter_hash = data.SearchConditionHash;
                            skyward.browse.get(browseName, {});
                        }
                    });
                };

                var updateIncidentListSelectedDisciplineOfficerUserSetting = function (staffID)
                {
                    $.ajax(
                    {
                        url: skyward.global.virtualDir + "Discipline/Incident/UpdateDisciplineOfficerStaffIDUserSetting",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            DisciplineOfficerStaffIDSelected: staffID
                        }
                    });
                };
            }

            if ($("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup").length > 0)
            {
                var studentNameFilter = $("#editIncidentOffenseName_StudentNameFilter_RadioButtonGroup");
                studentNameFilter.off('change');
                studentNameFilter.on('change', '.radioButtonContent', function ()
                {
                    var studentNameFilter = $(this);
                    var nameTypeStudentContainer = $('#editIncidentOffenseName_StudentSelection');
                    if (nameTypeStudentContainer.length == 0)
                    {
                        return;
                    }
                    var filterAjaxAction = nameTypeStudentContainer.find("#editIncidentOffenseName_StudentFilterAjaxAction");

                    var searchBox = nameTypeStudentContainer.find(".tileViewEEL_search");
                    var searchBoxData = searchBox.data();

                    var data = { "studentNameFilter": studentNameFilter.val() };
                    $.extend(data, searchBoxData);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Discipline/IncidentOffenseName/" + filterAjaxAction.val(),
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            success: function (data) {
                                searchBoxData.filter = JSON.parse(data.Filter);
                                searchBoxData.securityHash = data.NewHash;
                            }
                        });
                });
            }
            var incidentQuickEntryPrimaryOffenseChange = function ()
            {
                var codeEEL = $(this);
                var value = skyward.controls.getValue(codeEEL);
                var screenContainer = codeEEL.parents(".workflowPopup").first();

                screenContainer.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson").each(function ()
                {
                    updateReadOnlyPrimaryOffenseForInvolvedPerson($(this), value);
                });

                //Remove the offense we just set as primary from any existing secondary offense
                screenContainer.find(".incidentQuickEntrySecondaryOffenses").each(function ()
                {
                    var element = $(this);
                    if (element.attr("id").includes("-Template"))
                    {
                        return;
                    }

                    var backingDataElement = element.find(".dmsBackingData");
                    var secondaryOffenses = skyward.controls.getValue(backingDataElement);

                    if (secondaryOffenses)
                    {
                        $.each(secondaryOffenses, function (k, v)
                        {
                            if (k == value)
                            {
                                delete secondaryOffenses[k];
                                return false;
                            }
                        });
                    }

                    skyward.controls.setValue(backingDataElement, secondaryOffenses);
                    updateValidOffensesForAction(element);
                });
            };

            if ($(selector + ' .incidentQuickEntryPrimaryOffense').length > 0)
            {
                $(".incidentQuickEntryPrimaryOffense").on("eelComplete", incidentQuickEntryPrimaryOffenseChange);

                // We need to initialize the dependencies of the actionQuickEntry rows so that the dynamicfiltervalue collection is updated with the proper ids on the template row
                const actionQuickEntry = $(".actionQuickEntry");
                if (actionQuickEntry.length > 0)
                {
                    const actionTableRow = actionQuickEntry.find(".childrecordquickentryrow");

                    if (actionTableRow.length > 0)
                    {
                        setActionCodeEELDependency(actionTableRow);
                        setFollowUpDistintMultiSelectDependency(actionTableRow);
                    }
                }

                $(selector).on("childrecordquickentry-row-added", function ()
                {
                    var actionQuickEntry = $(event.target).parents(".actionQuickEntry");
                    if (actionQuickEntry.length < 1)
                    {
                        return;
                    }

                    var actionTableRow = actionQuickEntry.find(".childrecordquickentryrow:visible").last();

                    if (actionTableRow && actionTableRow.length)
                    {
                        setActionCodeEELDependency(actionTableRow);
                        setFollowUpDistintMultiSelectDependency(actionTableRow);
                        updateValidOffensesForAction(actionTableRow.children().first());

                        // Trigger a change to fire the ajax action for the intervention checkbox when adding a new action
                        actionQuickEntry.find(".isInterventionCheckbox:last").trigger("change");
                    }
                });

                $(selector).on("childrecordquickentry-row-added", ".childrecordquickentry.incidentQuickEntry", function ()
                {
                    //if its a nested crqe skip out.
                    if (event && event.target && $(event.target).parents(".incidentQuickEntryCollapsibleQuickEntry").first().length > 0)
                    {
                        return;
                    }

                    var quickEntry = $(this);
                    setTimeout(function () //Have to wait for the row added animation to be done...
                    {
                        var quickEntries = quickEntry.find("tbody > tr.incidentQuickEntryRow.childrecordquickentryrow:visible");
                        var addedRow = quickEntries.last();
                        var rowNumber = quickEntries.length;
                        var excludeOffense = addedRow.find(".excludePrimaryOffense");
                        var checked = skyward.controls.getValue(excludeOffense);

                        if (!checked)
                        {
                            var primaryOffenseValue = skyward.controls.getValue(quickEntryGetPrimaryOffense(addedRow));
                            updateReadOnlyPrimaryOffenseForInvolvedPerson(addedRow.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"), primaryOffenseValue);
                        }

                        var screenContainer = addedRow.parents(".workflowPopup").first();
                        var defaultOffenseValueFromPreviousPerson = skyward.controls.getValue(screenContainer.find("#DefaultOffenseValueFromPreviousPerson"));

                        if (defaultOffenseValueFromPreviousPerson.toLowerCase() == "true")
                        {
                            var previousRow = addedRow.prev(":visible");
                            cloneValuesFromPreviousRow(addedRow, previousRow);
                        }

                        var actionTableRow = addedRow.find('.actionQuickEntry').last().find(".childrecordquickentryrow").last();

                        if (actionTableRow && actionTableRow.length)
                        {
                            setActionCodeEELDependency(actionTableRow);
                            setFollowUpDistintMultiSelectDependency(actionTableRow);
                            updateValidOffensesForAction(addedRow.children().first());
                        }

                        const rowSuffix = `-add-${rowNumber}`;
                        initAllegationFieldsEvents(rowSuffix);
                        updateAllegationCheckbox(rowSuffix);
                    }, 250);
                });

                $(selector).on("change", ".incidentQuickEntrySecondaryOffenses", function ()
                {
                    var codeEEL = $(this);

                    updateValidOffensesForAction(codeEEL);
                });

                $(selector + " .childrecordquickentryrow").each(function ()
                {
                    var row = $(this);
                    updateValidOffensesForAction(row.find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson"));

                    //trigger an ajax action to default everything
                    row.find("[data-ajaxaction]").each(function ()
                    {
                        $(this).change();
                    });

                    excludePrimaryOffense.apply(row.find(".excludePrimaryOffense"));
                });

                // Add change events to allegation fields + run the update to hide / show the isAllegation checkbox on load
                const firstRowSuffix = "-add-1";
                initAllegationFieldsEvents(firstRowSuffix);
                updateAllegationCheckbox(firstRowSuffix);
            }

            setPennsylvaniaFieldsVisability(selector);
        };

        /**
         * This function adds the 'change' events to the controls that determine
         * the visibility of the isAllegation checkbox and StaffAllegationFields.
         *
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var initAllegationFieldsEvents = function (rowSuffix)
        {
            const incidentTypeData = { rowSuffix: rowSuffix, allegationFieldsCB : updateAllegationFieldsForAllRows }
            const allegationCheckboxData = { rowSuffix : rowSuffix, allegationFieldsCB : updateAllegationCheckbox }
            const staffAllegationFieldsData = { rowSuffix : rowSuffix, allegationFieldsCB : updateStaffAllegationFields }

            $("#IncidentTypeCode").off("change", updateAllegationFields).on("change", incidentTypeData, updateAllegationFields);
            $(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", allegationCheckboxData, updateAllegationFields);
            $(`#IncidentOffenseNameIsAllegation${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
            $(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`).off("change", updateAllegationFields).on("change", staffAllegationFieldsData, updateAllegationFields);
        }

        /**
         * This function gets the data passed from the change event
         * and executes the callback to update the necessary allegation fields
         *
         * @param event
         */
        var updateAllegationFields = function (event)
        {
            const rowSuffix = event.data.rowSuffix;
            const allegationFieldsCB = event.data.allegationFieldsCB;

            if (rowSuffix !== undefined && allegationFieldsCB !== undefined)
            {
                allegationFieldsCB(rowSuffix);
            }
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateAllegationCheckbox = function (rowSuffix)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "Incident.TypeCode": skyward.controls.getValue($("#IncidentTypeCode")),
                "IncidentOffenseName.IsAllegation": skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.InvolvementTypeCode": skyward.controls.getValue($(`#IncidentOffenseNameInvolvementTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}AllegationCheckboxWorkflowAjax`,
                    type: "POST", 
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                        updateStaffAllegationFields(rowSuffix, data.Update);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the StaffAllegationFields
         * 
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         * @param {object | undefined} updatedData - Contains data retrieved in updateAllegationCheckbox's ajax call
         */
        var updateStaffAllegationFields = function (rowSuffix, updatedData)
        {
            const portalForAjax = skyward.controls.getValue($("#PortalForAjax"));
            const postData =
            {
                "IncidentOffenseName.IsAllegation": updatedData !== undefined ?
                    updatedData["IncidentOffenseName.IsAllegation"] : skyward.controls.getValue($(`#IncidentOffenseNameIsAllegation${rowSuffix}`)),
                "IncidentOffenseName.IncidentOffenseNameTypeCode" : skyward.controls.getValue($(`#IncidentOffenseNameIncidentOffenseNameTypeCode${rowSuffix}`))
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + `Discipline/IncidentOffenseName/QuickEntry${portalForAjax}StaffAllegationFieldsWorkflowAjax`,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        updateData(data, rowSuffix);
                    }
                });
        }

        /**
         * This function calls the controller action to
         * determine if we should hide the isAllegation checkbox 
         * for each Involved person row in the quick entry
         * 
         * @param {string} rowSuffix - Specifies the row of the last QuickEntry
         */
        var updateAllegationFieldsForAllRows = function (rowSuffix)
        {
            const match = rowSuffix.match(/-add-(\d+)/);
            if (match)
            {
                const rows = parseInt(match[1], 10);
                for (let row = 1; row <= rows; row++)
                {
                    updateAllegationCheckbox(`-add-${row}`);
                }
            }
        }

        /**
         * Iterate through the Update, and Hidden dictionaries and
         * update their corresponding controls' values + visibility
         * 
         * @param {object} data - Contains Update, and Hidden dictionaries retrieved in ajax call
         * @param {string} rowSuffix - Specifies the row of the current QuickEntry
         */
        var updateData = function (data, rowSuffix)
        {
            const processDictionary = function (dict, callback)
            {
                if (dict !== undefined)
                {
                    for (const selector in dict)
                    {
                        if (dict.hasOwnProperty(selector))
                        {
                            callback(`#${selector.replace(".", "")}${rowSuffix}`, dict[selector]);
                        }
                    }
                }
            }

            if (data !== undefined)
            {
                processDictionary(data.Update, (selector, value) => skyward.controls.setValue(selector, value, true));
                processDictionary(data.Hidden, (selector, hide) => skyward.controls.toggleVisible(selector, !Boolean(hide)));
            }
        }

        var cloneValuesFromPreviousRow = function (addedRow, previousRow)
        {
            cloneFieldFromPreviousRow(addedRow, previousRow, ".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
        };

        var cloneFieldFromPreviousRow = function (addedRow, previousRow, fieldSelector)
        {
            var previousField = previousRow.find(fieldSelector);
            var addedField = addedRow.find(fieldSelector);

            if (addedField.length > 0 && previousField.length > 0)
            {
                skyward.controls.setValue(addedField, skyward.controls.getValue(previousField));
            }
        };

        var updateReadOnlyPrimaryOffenseForInvolvedPerson = function (codeEELForPerson, newPrimaryOffenseValue)
        {
            skyward.controls.setValue(codeEELForPerson, newPrimaryOffenseValue, true);
        };

        var excludePrimaryOffense = function ()
        {
            var checkbox = $(this);
            var row = checkbox.parents(".childrecordquickentryrow").first();
            var checked = skyward.controls.getValue(checkbox);

            var readOnlyPrimaryOffense = checkbox.parents(".childrecordquickentryrow").first().find(".incidentQuickEntryPrimaryOffenseForInvolvedPerson");

            if (checked)
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, null);
            }
            else
            {
                skyward.controls.setValue(readOnlyPrimaryOffense, skyward.controls.getValue(quickEntryGetPrimaryOffense(checkbox)));
            }
            updateValidOffensesForAction(checkbox);
            row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData").change();
        };

        var updateValidOffensesForAction = function (element)
        {
            var row = element.parents(".childrecordquickentryrow").first();

            var selectedOffenseIDs = getSelectedOffenseIDs(row);

            skyward.controls.setValue(row.find(".selectedOffensesForInvolvedPerson"), JSON.stringify(selectedOffenseIDs));
            if (selectedOffenseIDs.length > 0)
            {
                defaultOffenseForAction(row, selectedOffenseIDs);
            }
        };

        var getSelectedOffenseIDs = function (row)
        {
            var primaryOffenseCodeEEL = quickEntryGetPrimaryOffense(row);
            var excludePrimary = skyward.controls.getValue(row.find(".excludePrimaryOffense"));

            var selectedOffenseIDs = [];
            if (!excludePrimary)
            {
                var primaryOffenseID = skyward.controls.getValue(primaryOffenseCodeEEL);
                if (primaryOffenseID)
                {
                    selectedOffenseIDs.push(primaryOffenseID);
                }
            }

            var secondaryOffensesBackingDataElement = row.find(".incidentQuickEntrySecondaryOffenses > .dmsBackingData");
            var secondaryOffenses = skyward.controls.getValue(secondaryOffensesBackingDataElement);
            if (secondaryOffenses)
            {
                $.each(secondaryOffenses, function (k, v)
                {
                    if (k != null && k != "")
                    {
                        selectedOffenseIDs.push(k);
                    }
                });
            }

            return selectedOffenseIDs;
        };

        var defaultOffenseForAction = function (row, selectedOffenseIDs)
        {
            var actionOffenseCodeEELs = row.find(".incidentQuickEntryOffenseIDForAction");
            $.each(actionOffenseCodeEELs, function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (!value || !selectedOffenseIDs.indexOf(value) > -1)
                {
                    skyward.controls.setValue(element, selectedOffenseIDs[0]);
                }
            });
        };

        var quickEntryGetPrimaryOffense = function (element)
        {
            var screenContainer = element.parents(".workflowPopup").first();
            return screenContainer.find(".incidentQuickEntryPrimaryOffense");
        };

        var setActionCodeEELDependency = function (actionTableRow)
        {
            var actionCodeEELInputs = actionTableRow.find(".js-setActionCodeEELDependency");
            $.each(actionCodeEELInputs, function ()
            {
                var actionCodeEEL = $(this).find(".eELInputContainer__textBox").first();
                if (actionCodeEEL)
                {
                    var fieldname = "IncidentOffenseNameActionActionID";

                    var actionCodeEELID = actionCodeEEL.attr("id");
                    var actionCodeEELPrefix = actionCodeEELID.split(fieldname)[0];
                    var actionCodeEelDynamicFilter = actionCodeEEL.data().dynamicfiltervalue;

                    var actionRepeaterNumberForIncident = actionCodeEEL.parents(".codeEEL").attr("id").split(fieldname)[1];
                    if (actionRepeaterNumberForIncident != actionCodeEelDynamicFilter.split("IncidentOffenseNameAction.OffenseIDForAction")[1])
                    {
                        actionCodeEelDynamicFilter = "IncidentOffenseNameAction.OffenseIDForAction" + actionRepeaterNumberForIncident;
                    }

                    if (actionCodeEelDynamicFilter.indexOf(actionCodeEELPrefix) < 0)
                    {
                        actionCodeEelDynamicFilter = actionCodeEELPrefix + actionCodeEelDynamicFilter;
                        actionCodeEEL.data("dynamicfiltervalue", actionCodeEelDynamicFilter);
                    }
                }
            });
        }

        var setFollowUpDistintMultiSelectDependency = function (actionTableRow)
        {
            var followUpEEL = actionTableRow.find(".js-setFollowUpDistintMultiSelectDependency");
            var followUpEELID = followUpEEL.attr("id");

            if (followUpEELID)
            {
                var fieldName = "IncidentOffenseNameActionAdditionalFollowUpTypesMultiSelect";
                var followUpEELPrefix = followUpEELID.split(fieldName)[0];
                var followUpEELRepeaterNumber = followUpEELID.split(fieldName)[1];
                var followUpEELDynamicFilter = followUpEEL.data().dynamicfiltervalue.split(",")[0];  // Ignore the EdFiApplicationID dependency

                if (followUpEELRepeaterNumber != followUpEELDynamicFilter.split("IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType")[1])
                {
                    followUpEELDynamicFilter = "IncidentOffenseNameAction.DescriptorCodeIDPrimaryFollowUpType" + followUpEELRepeaterNumber;
                }

                if (followUpEELDynamicFilter.indexOf(followUpEELPrefix) < 0)
                {
                    followUpEELDynamicFilter = followUpEELPrefix + followUpEELDynamicFilter;
                }

                followUpEELDynamicFilter = followUpEELDynamicFilter + ",EdFiApplicationID";
                followUpEEL.data("dynamicfiltervalue", followUpEELDynamicFilter);
                skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(followUpEEL);
            }
        };

        var applyPartialDayDuration = function ()
        {
            $(this).on('input change', function (e)
            {
                var actionDateFieldsParent = $(this).parents('.actionDateFields');
                var hiddenCheckbox = actionDateFieldsParent.find('.hiddenApplyPartialToServeOnStartDate');
                var durationTypeLabel = actionDateFieldsParent.find('.durationTypeLabel')

                var val = $(this).val();
                var valAsInt = parseInt(val) || 0;
                var hideCheckbox = !val || valAsInt == val || valAsInt < 1 || durationTypeLabel.text() == 'Hours';

                skyward.controls.setValue(hiddenCheckbox, hideCheckbox);
            });
        }

        var setPennsylvaniaStateReportingFields = function ()
        {
            $("#IncidentTypeCode")
                .off("change.pa")
                .on("change.pa", updatePARequiredAsterisk);
        }

        function updatePARequiredAsterisk()
        {
            var code = skyward.controls.getValue($("#IncidentTypeCode"));
            var isRequired = (code === "I");

            toggleLabelAsterisk(
                "IncidentPropertyDescription",
                isRequired
            );
        }

        function toggleLabelAsterisk(id, show)
        {
            var $label = $(document.getElementById(id)?.labels?.[0]);

            var propertyDescriptionAsterisk = $label.find("span.requiredAsterisk");

            if (show)
            {
                propertyDescriptionAsterisk.show();
            }
            else
            {
                propertyDescriptionAsterisk.hide();
            }
        }

        var setPennsylvaniaFieldsVisability = function (selector, incidentTypeCodeID)
        {
            const setStateOffenderTypePA = () =>
            {
                if (skyward.controls.getValue(incidentTypeCodeID) == "")
                {
                    incidentTypeCodeID = $(selector).parents().find(".incidentTypeCode");
                }

                let incidentTypeCode = skyward.controls.getValue(incidentTypeCodeID);

                if (incidentTypeCode != null) // This should only happen while the page is loading
                {
                    for (var j = 0; j < involvedPersonTypeIDs.length; ++j)
                    {
                        let suffix = '-';
                        if (typeof involvedPersonTypeIDs[j].id === 'string')
                        {
                            suffix = suffix.concat(involvedPersonTypeIDs[j].id.split('-').at(-1));
                        }
                        else
                        {
                            continue;
                        }
                        // Get variables to determine visibility
                        let currentInvolvementTypeCodeID = involvementTypeCodeIDs.filter((div) => div.id.endsWith(suffix));
                        let currentInvolvedPersonTypeID = involvedPersonTypeIDs.filter((div) => div.id.endsWith(suffix));
                        let involvementTypeCode = skyward.controls.getValue(currentInvolvementTypeCodeID);
                        let involvedPersonTypeCode = skyward.controls.getValue(currentInvolvedPersonTypeID);

                        // Get variables to show/hide
                        let currentStateOffenderTypePAID = stateOffenderTypePAIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAVictimFieldsID = paVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderAndVictimFieldsID = paOffenderAndVictimFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsNonFreeformID = paOffenderFieldsNonFreeformIDs.filter((div) => div.id.endsWith(suffix));
                        let currentPAOffenderFieldsSectionHeaderID = paOffenderFieldsSectionHeaderIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsID = freeformOtherNameFieldsIDs.filter((div) => div.id.endsWith(suffix));
                        let currentFreeformOtherNameFieldsVictimAndOffenderID = freeformOtherNameFieldsVictimAndOffenderIDs.filter((div) => div.id.endsWith(suffix));

                        if (involvementTypeCode == 'O' && incidentTypeCode == 'I')
                        {
                            if (involvedPersonTypeCode == 'FRE' || involvedPersonTypeCode == 'OTH')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentFreeformOtherNameFieldsID).show();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            }
                            else
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).hide();
                                $(currentFreeformOtherNameFieldsID).hide();
                                $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                            }
                        }
                        else if (involvementTypeCode == 'V' && (involvedPersonTypeCode == 'OTH' || involvedPersonTypeCode == 'FRE') && incidentTypeCode == 'I')
                        {
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).show();
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                        }
                        else
                        {
                            $(currentFreeformOtherNameFieldsID).hide();
                            $(currentPAOffenderFieldsSectionHeaderID).hide();
                            $(currentFreeformOtherNameFieldsVictimAndOffenderID).hide();
                        }

                        if (incidentTypeCode == 'I')
                        {
                            if (involvementTypeCode == 'O')
                            {
                                $(currentPAOffenderFieldsSectionHeaderID).show();
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentStateOffenderTypePAID).show();
                                $(currentPAOffenderFieldsNonFreeformID).show();
                                $(currentPAVictimFieldsID).hide();
                            }
                            else if (involvementTypeCode == 'V')
                            {
                                $(currentPAOffenderAndVictimFieldsID).show();
                                $(currentPAVictimFieldsID).show();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                                $(currentStateOffenderTypePAID).hide();
                            }
                            else
                            {
                                $(currentPAOffenderAndVictimFieldsID).hide();
                                $(currentPAVictimFieldsID).hide();
                                $(currentStateOffenderTypePAID).hide();
                                $(currentPAOffenderFieldsNonFreeformID).hide();
                            }
                        }
                        else
                        {
                            $(currentStateOffenderTypePAID).hide();
                            $(currentPAVictimFieldsID).hide();
                            $(currentPAOffenderAndVictimFieldsID).hide();
                            $(currentPAOffenderFieldsNonFreeformID).hide();
                        }
                    }
                }
            }

            // Variables to watch for change
            var incidentTypeCodeID = $(selector).find(".incidentTypeCode")
            var involvementTypeCodeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameInvolvementTypeCode-"]')];
            var involvedPersonTypeIDs = [...document.querySelectorAll('[id*="IncidentOffenseNameIncidentOffenseNameTypeCode-"]')];

            // Divs to show/hide
            var stateOffenderTypePAIDs = [...document.querySelectorAll('[id*="fsStateOffenderTypePA-"]')];
            var paVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAVictimFields-"]')];
            var paOffenderAndVictimFieldsIDs = [...document.querySelectorAll('[id*="fsPAOffenderAndVictimFields-"]')];
            var paOffenderFieldsNonFreeformIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsNonFreeform-"]')];
            var paOffenderFieldsSectionHeaderIDs = [...document.querySelectorAll('[id*="fsPAOffenderFieldsSectionHeader-"]')];
            var freeformOtherNameFieldsIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFields-"]')];
            var freeformOtherNameFieldsVictimAndOffenderIDs = [...document.querySelectorAll('[id*="fsFreeformOtherNameFieldsVictimAndOffender-"]')];

            // Attach event handlers
            $(incidentTypeCodeID).on('change', () => setStateOffenderTypePA());
            for (var i = 0; i < involvementTypeCodeIDs.length; i++)
            {
                $(involvementTypeCodeIDs[i]).on('change', () => setStateOffenderTypePA());
                $(involvedPersonTypeIDs[i]).on('change', () => setStateOffenderTypePA());
            }

            // Run each time a new person is added to the incident
            setStateOffenderTypePA();
        }

        var initStudentIndicatorDisplay = function ()
        {
            var studentindicatorbutton = $(this);
            var incidentQuickEntryIndicators = studentindicatorbutton.parents(".incidentQuickEntryIndicators").first();
            skyward.controls.hide(incidentQuickEntryIndicators.parent());
            var removeDuplicates = function (indicatorParent)
            {
                if (indicatorParent.find(".incidentQuickEntryIndicators").length > 1)
                {
                    indicatorParent.find(".incidentQuickEntryIndicators").first().remove();
                    removeDuplicates(indicatorParent);
                }
                else
                {
                    skyward.controls.show(indicatorParent);
                }
            };
            setTimeout(
                function () 
                {
                    removeDuplicates(incidentQuickEntryIndicators.parent());
                }, 10); //Account for ajax being processed at exact same time.
        };

        var events =
        {
            'excludePrimaryOffense': excludePrimaryOffense,
            'applyPartialDayDuration': applyPartialDayDuration,
            'setPennsylvaniaFieldsVisability': setPennsylvaniaFieldsVisability,
            'setPennsylvaniaStateReportingFields': setPennsylvaniaStateReportingFields,
            'initStudentIndicatorDisplay': initStudentIndicatorDisplay,
        };

        skyward.window.registerLoadDOMCallback(init);
        skyward.events.registerEvents('disciplineQuickEntry', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
